import { useGooglePlacesContext } from '../context/context';

export function useAutocompleteService(): typeof google.maps.places.AutocompleteSuggestion | undefined {
	const googlePlacesContext = useGooglePlacesContext();

	return googlePlacesContext?.autocompleteService;
}
